// import CheckIcon from '@mui/icons-material/Check';

import { Header, Page, TabbedLayout } from '@backstage/core-components';
import UsersPage from './users/UsersPage';
import './Administration.css';

const AdministrationComponent = () => {
  return (
    <Page themeId='administration'>
      <Header title="Administration" type='Admin' tooltip='Manager component' />
      <TabbedLayout>
        <TabbedLayout.Route path="/user-config" title="User Configurations">
          <UsersPage />
        </TabbedLayout.Route>
      </TabbedLayout>
    </Page>
  );
};

export default AdministrationComponent;